import {useMemo} from 'react';
import {isIOS, isMobile} from 'react-device-detect';
import {chainIdToNetworkName} from '../../lib/chains';
import {selectWallet} from '../../redux/wallet.slice';
import {useAppSelector} from '../hooks';
import useProjectById from './useProjectById';

const useInvestFormValidation = (projectData: ReturnType<typeof useProjectById>, isEmbed?: boolean) => {
  const {chainId, address} = useAppSelector(selectWallet);
  const chainName = chainIdToNetworkName[chainId];
  const unsupportedValidation = useMemo(() => {
    return {
      validate: !(isIOS && isMobile && isEmbed),
      message: 'To invest, go to the project page',
    };
  }, [isEmbed]);

  const formValidation = useMemo(() => {
    if (!projectData.project) return [unsupportedValidation];
    return [
      {
        validate: address ? !!projectData.project.projectExternals?.find(el => el.network?.symbol === chainName) : true,
        message: 'Unsupported network',
      },
      {
        validate: address
          ? projectData.project.projectExternals?.find(el => el.network?.symbol === chainName)?.isActive
          : true,
        message: 'Fundraising has stopped',
      },
      {
        validate: projectData.project.isActive,
        message: 'Fundraising has stopped',
      },
      {
        validate: +(projectData.project?.endDate || 0) * 1000 > new Date().getTime(),
        message: 'Fundraising already ended',
      },
      {
        validate: +(projectData.project?.startDate || 0) * 1000 < new Date().getTime(),
        message: 'Fundraising will start soon',
      },
      unsupportedValidation,
    ];
  }, [address, chainName, projectData, unsupportedValidation]);

  const formError = useMemo(() => {
    return formValidation.find(el => !el.validate)?.message;
  }, [formValidation]);

  return {
    formError,
  };
};

export default useInvestFormValidation;
